import { useQuery, useInfiniteQuery } from 'react-query';
import { fetcher } from '../../client'
import { fetchTemplateList, fetchRequestedTemplateList } from '../../actions/templates'

export function useTemplateList(params = {}, options) {
  return useQuery(['templates', params], () => fetcher(fetchTemplateList(params)), options) 
}
export function useInfiniteTemplateList(params, options) {
  return useInfiniteQuery(['templates', params], ({ pageParam = 1 }) => fetcher(fetchTemplateList({ ...params, page: pageParam })), options)
}
export function useRequestedTemplateList(params = {}, options) {
  return useQuery(['requested-templates', params], () => fetcher(fetchRequestedTemplateList(params)), options) 
}
export function useInfiniteRequestedTemplateList(params = {}, options) {
  return useInfiniteQuery(['requested-templates', params], ({ pageParam = 1 }) => fetcher(fetchRequestedTemplateList({ ...params, page: pageParam })), options) 
}